<div class="w-6 h-6 border rounded transition flex items-center justify-center"
  [class.bg-primary-one]="checked" [class.bg-white]="!checked"
  [class.border-gray-200]="!checked" [class.border-primary-one]="checked" (click)="toggle($event)">
  <img src="/assets/images/icon-check.svg" class="w-4 h-4 transition-opacity" [class.opacity-0]="!checked">
</div>
